function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { string, object, node, func, oneOfType } from 'prop-types';
import { generateClassNames, getPipedProps } from './../utils';
import { makeParamsObj, makeParamsObjFromSassMap, makeComplexAttributePropType } from './../../utils/helpers';
import { UI } from './../../utils';
import css from './FontSize.sass';
var localPropsMap =
/*#__PURE__*/
makeParamsObjFromSassMap(css.props);
var fontSize =
/*#__PURE__*/
makeParamsObj(UI.SIZES.fontSizes);
var breakpoint =
/*#__PURE__*/
makeParamsObj(UI.BREAKEPOINTS);

var FontSize = function FontSize(props) {
  var _getPipedProps = getPipedProps(props, props.propsMap, localPropsMap),
      InputComponent = _getPipedProps.InputComponent,
      propsMap = _getPipedProps.propsMap,
      className = _getPipedProps.className,
      pipedProps = _objectWithoutProperties(_getPipedProps, ["InputComponent", "propsMap", "className"]);

  return React.createElement(InputComponent, _objectSpread({}, pipedProps, {
    className: generateClassNames(props, propsMap, localPropsMap, className, css)
  }));
};

FontSize.propTypes =
/*#__PURE__*/
_objectSpread({
  className: string,

  /** Map for local props */
  propsMap: object,

  /** Component for enhancement */
  InputComponent:
  /*#__PURE__*/
  oneOfType([node, func])
},
/*#__PURE__*/
makeComplexAttributePropType([
/*#__PURE__*/
Object.keys(localPropsMap),
/*#__PURE__*/
// eslint-disable-line array-element-newline
Object.keys(breakpoint)],
/*#__PURE__*/
Object.keys(fontSize)));
Object.assign(FontSize, {
  localPropsMap: localPropsMap,
  fontSize: fontSize,
  breakpoint: breakpoint
});
export { FontSize };